// src/pages/CouponPage.jsx
import React, { useState } from "react";
import Layout from "../components/Layout";
import CouponCreate from "./CouponCreate";
import CouponList from "./CouponList";
import "./CouponPage.css";

export default function CouponPage() {
  const [activeTab, setActiveTab] = useState("create");

  return (
    <Layout title="Coupons">
      <div className="coupon-page">
        <div className="coupon-page__header">
          <div>
            <h2>Coupon Management</h2>
            <p>Create coupon codes and track where they are used.</p>
          </div>
        </div>

        <div className="coupon-tabs">
          <button
            type="button"
            className={activeTab === "create" ? "active" : ""}
            onClick={() => setActiveTab("create")}
          >
            Create Coupon
          </button>

          <button
            type="button"
            className={activeTab === "list" ? "active" : ""}
            onClick={() => setActiveTab("list")}
          >
            List Coupons
          </button>
        </div>

        <div className="coupon-body">
          {activeTab === "create" ? <CouponCreate /> : <CouponList />}
        </div>
      </div>
    </Layout>
  );
}